import datepicker from 'vuejs-datepicker';
import axios from 'axios';

import * as headerBlock from '../header/';
import Autocomplete from '../autocomplete/vue-autocomplete.vue';
import AreaCheckbox from '../areaCheckbox/';
import Thumbnail from '../thumbnail';
import Uploading from '../uploading';

const alert = require('vue-strap').alert;
const spinner = require('vue-strap').spinner;
// const datepicker = require('vue-strap').datepicker;


export default {
  name: 'task-config',
  props: [
    'onLogout',
    'access_token',
    'authUser',
    'duplicate',
  ],
  components: {
    headerBlock,
    Autocomplete,
    AreaCheckbox,
    alert,
    datepicker,
    spinner,
    Thumbnail,
    Uploading,
  },
  mounted() {

  },
  data() {
    return {
      formData: {
        name: '',
        description: '',
        role: 'basic',
        selectedContent: '',
        picture: '',
        img: null,
        video: '',
        video_url: '',
        video_thumbnail: '',
        img_thumbnail: null,
        video_require: false,
        deeplink: {
          active: false,
          item: 'checklist',
          id: null,
          badId: false,
          name: null,
        },
        description_file: '',
        description_file_url: '',
        instructionSteps: [],
        workAreas: [],
        suggestArea: [],
      },

      weekDays: [
        { label: 'Monday', value: 2 },
        { label: 'Tuesday', value: 3 },
        { label: 'Wednesday', value: 4 },
        { label: 'Thursday', value: 5 },
        { label: 'Friday', value: 6 },
        { label: 'Saturday', value: 7 },
        { label: 'Sunday', value: 1 },
      ],

      deeplinks: [
        { name: 'audit', id: 1 },
        { name: 'checklist', id: 1 },
      ],
      areas: [],
      taskTemplates: [],
      checklists: [],
      audits: [],
      // areasChecked: '',
      shifts: {
        sunday: [],
        monday: [],
        tuesday: [],
        wednesday: [],
        thursday: [],
        friday: [],
        saturday: [],

      },
      emptyStep: {
        id: null,
        order: 1,
        description: '',
        picture: '',
        valid: true,
        img: '',
        imgChanged: false,
        selectedContent: '',
        video: '',
        video_url: '',
        video_thumbnail: '',
        img_thumbnail: null,
        video_require: false,
      },
      emptyWorkArea: {
        area: [],
        areaFromList: false,
        scheduler: {
          id: null,
          fromDate: null,
          toDate: null,
          forever: true,
          tabIndex: 0,
          byShift: {
            fields: {},
            items: [],
            isNotChecked: true,
          },
          weekly: {
            recurWeek: 1,
            selected: [1, 2, 3, 4, 5, 6, 7],
            is_once_per_week: true,
          },
          monthly: {
            // type: 1,
            is_once_per_month: true,
            recurDay: {
              day: 1,
              month: 1,
            },
            recurWeekDay: {
              every: 1,
              weekDay: 1,
              month: 1,
            },

          },
          oneDay: {
            date: null,
            weekday: 'monday',
            shifts: [],
            fields: {},
            field: {},
            items: [],
            item: [],
            isNotChecked: true,
          },
          type: {
            selected: 0,
            options: [
              { text: 'Recurring', value: 0 },
              { text: 'On one day', value: 1 },
            ],
          },
        },
      },
      weekdays: [],
      weekNumbersItem: [
        { text: 'First', value: 1 },
        { text: 'Second', value: 2 },
        { text: 'Third', value: 3 },
        { text: 'Fourth', value: 4 },
      ],
      userRoles: [],
      hasSaveError: false,
      needFill: false,
      breadCrumbItems: [
        {
          text: 'Home',
          to: `${process.env.START_URL}/`,
        }, {
          text: 'Tasks',
          to: `${process.env.START_URL}/constructor/Tasks`,
        },
        {
          text: 'Constructor',
          active: true,
        },
      ],
      alertError: {
        text: 'Some fields are not filled',
        title: 'Error!',
        visible: false,
      },
      alertSuccess: {
        text: 'Saved successfully, tab will be closed in 3 seconds',
        title: '',
        visible: false,
      },
      upload: {
        total: 1,
        uploaded: 0,
        image: true,
        visible: false,
      },
      taskId: null,
      processLoading: false,
      stepsMustDelete: [],
      recurrenciesMustDelete: [],
    };
  },
  methods: {
    readURL(input, item) {
      if (input.files && input.files[0]) {
        // item.pictureBugFixer = input.files[0];
        const reader = new FileReader();
        reader.onload = ((e) => {
          // $('#icon').attr('src', e.target.result);
          item.img = e.target.result;
        });

        reader.readAsDataURL(input.files[0]);
      }
    },
    handleVideoFileChange(e) {
      if (e.target.files && e.target.files[0] && e.target.files[0].size > 50000000) {
        e.target.value = '';
        this.alertError.text = 'Maximum allowed video size is 50 MB.';
        this.alertError.visible = true;
        return;
      }
    },
    // createUserRoles() {
    //   if (this.authUser && this.authUser.company) {
    //     this.userRoles.push({
    //       name: this.authUser.company.basic_role_display_name || 'Basic user',
    //       id: 'basic',
    //     });
    //     this.userRoles.push({
    //       name: this.authUser.company.shift_leader_role_display_name || 'Shift leader',
    //       id: 'shift_leader',
    //     });
    //     this.userRoles.push({
    //       name: this.authUser.company.manager_role_display_name || 'Manager',
    //       id: 'manager',
    //     });
    //   }
    // },
    getCompany() {
      function assignDefaultRoles() {
        this.userRoles.push({
          name: 'Basic user',
          id: 'basic',
        });
        this.userRoles.push({
          name: 'Shift leader',
          id: 'shift_leader',
        });
        this.userRoles.push({
          name: 'Manager',
          id: 'manager',
        });
      }
      let id = null;
      if (this.authUser && this.authUser.company && this.authUser.company.id) {
        id = this.authUser.company.id;
      }
      if (this.$route.params.companyId) {
        id = this.$route.params.companyId;
      }
      if (!id) {
        assignDefaultRoles();
        return null;
      }
      return this.$http.get(`companies/${id}/`,
        {
          method: 'GET',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
        })
        .then((response) => {
          if (response.status !== 200) {
            assignDefaultRoles();
            this.alertError.text = this.getErrorText(response);
            return response.status;
          }
          this.userRoles = [];
          this.userRoles.push({
            name: response.body.basic_role_display_name || 'Basic user',
            id: 'basic',
          });
          this.userRoles.push({
            name: response.body.shift_leader_role_display_name || 'Shift leader',
            id: 'shift_leader',
          });
          this.userRoles.push({
            name: response.body.manager_role_display_name || 'Manager',
            id: 'manager',
          });
          return response.status;
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
        });
    },
    createShiftsField() {
      const fields = this.emptyWorkArea.scheduler.byShift.fields;
      let index = 1;
      fields.monday = null;
      fields.tuesday = null;
      fields.wednesday = null;
      fields.thursday = null;
      fields.friday = null;
      fields.saturday = null;
      fields.sunday = null;

      for (const key in this.shifts) {
        fields[key] = {
          label: `${key.charAt(0).toUpperCase() + key.slice(1)}
                  <div class="select-shift-table__header">
                  Select all shifts</div>`,
          name: (key.charAt(0).toUpperCase() + key.slice(1)),
          value: index,
          class: 'td',
          allSelected: false,
        };
        this.weekdays.push({
          text: (key.charAt(0).toUpperCase() + key.slice(1)),
          value: index,
        });
        index++;
      }
      this.emptyWorkArea.scheduler.oneDay.fields = JSON.parse(JSON.stringify(fields));
    },
    updateShiftsTableData(fromIndex = 0) {
      for (let workAreasIndex = fromIndex;
           workAreasIndex < this.formData.workAreas.length;
           workAreasIndex++) {
        const byShift = this.formData.workAreas[workAreasIndex].scheduler.byShift;
        const oneDay = this.formData.workAreas[workAreasIndex].scheduler.oneDay;
        byShift.items = [];
        for (const key in this.shifts) {
          const self = this;
          const shiftsList = this.shifts[key].filter((item) => {
            if (!self.formData.workAreas[workAreasIndex].area.length) {
              return false;
            }
            if (!self.formData.workAreas[workAreasIndex].area[0].custom_shifts) {
              return item.area === null;
            }
            return item.area == self.formData.workAreas[workAreasIndex].area[0].id;
          });
          for (let i = 0; i < shiftsList.length; i++) {
            if (byShift.items.length <= i) {
              byShift.items.push({});
            }
            byShift.items[i][key] = {
              value: shiftsList[i].time,
              id: shiftsList[i].id,
              checked: shiftsList[i].checked,
            };
          }
        }
        oneDay.items = JSON.parse(JSON.stringify(byShift.items));
        this.updateOneDayShifts(oneDay);
      }
    },
    updateOneDayShifts(item) {
      function clearChecked(items) {
        for (const key in items) {
          items[key].checked = false;
        }
      }
      if (!item.date) {
        return;
      }
      let weekday = new Date(item.date).getDay();
      if (!isNaN(weekday) && weekday != null) {
        // if (weekday === 0) {
        //   weekday = 7;
        // }
        weekday += 1;
        console.log(weekday);
        item.field = {};
        item.item = [];
        item.isNotChecked = true;
        for (const key in item.fields) {
          if (item.fields[key].value == weekday) {
            item.field[key] = item.fields[key];
            for (let i = 0; (i < item.items.length) && (item.items[i][key]); i++) {
              clearChecked(item.items[i]);
              item.item.push(item.items[i]);
            }
            console.log(key);
            return;
          }
        }
      }
    },
    onClickShift(items, key, index) {
      const item = items.items[index][key];
      item.checked = !item.checked;
      const flagAllChecked = this.isSelectedAllShifts(items, key);
      items.fields[key].allSelected = flagAllChecked;
      items.items.push({});
      items.items.splice(items.items.length - 1, 1);
      items.isNotChecked = true && !items.fields[key].allSelected;
      if (!items.isNotChecked) return;
      for (let i = 0; i < items.items.length; i++) {
        for (const weekdayKey in items.items[i]) {
          if (items.items[i][weekdayKey] && items.items[i][weekdayKey].checked) {
            items.isNotChecked = false;
          }
        }
      }
    },
    isSelectedAllShifts(item, key) {
      let flagAllChecked = true;
      for (let i = 0; i < item.items.length; i++) {
        if (item.items[i][key]) {
          flagAllChecked = flagAllChecked && item.items[i][key].checked;
        }
      }
      return flagAllChecked;
    },
    onSelectAllShifts(key, item) {
      const flagAllChecked = this.isSelectedAllShifts(item, key);
      for (let i = 0; i < item.items.length; i++) {
        if (item.items[i][key]) {
          item.items[i][key].checked = !flagAllChecked;
        }
      }
      item.fields[key].allSelected = !flagAllChecked;
      item.items.push({});
      item.items.splice(item.items.length - 1, 1);
      item.isNotChecked = true;
      if (!item.isNotChecked) return;
      for (let i = 0; i < item.items.length; i++) {
        for (const weekDayKey in item.items[i]) {
          if (item.items[i][weekDayKey] && item.items[i][weekDayKey].checked) {
            item.isNotChecked = false;
          }
        }
      }
    },
    addOneMoreArea() {
      this.formData.workAreas.push(JSON.parse(JSON.stringify(this.emptyWorkArea)));
      this.updateShiftsTableData(this.formData.workAreas.length - 1);
    },
    deleteOneArea(index) {
      if (this.formData.workAreas[index].scheduler.id) {
        this.recurrenciesMustDelete.push(this.formData.workAreas[index].scheduler.id);
      }
      this.formData.workAreas.splice(index, 1);
    },
    addNewStep() {
      let maxStepOrder = 0;
      const self = this;
      const orders = [];
      let orderCount = 1;
      for (let i = 0; i < self.formData.instructionSteps.length; i++) {
        orders.push(+self.formData.instructionSteps[i].order);
        if (maxStepOrder < self.formData.instructionSteps[i].order) {
          maxStepOrder = self.formData.instructionSteps[i].order;
        }
      }
      for (let i = 1; i <= +maxStepOrder + 1; i++) {
        if (orders.indexOf(i) === -1) {
          orderCount = i;
          break;
        }
      }
      self.formData.instructionSteps.push(JSON.parse(JSON.stringify(self.emptyStep)));
      self.formData.instructionSteps[self.formData.instructionSteps.length - 1].order = orderCount;
    },
    removeStep(index) {
      if (this.formData.instructionSteps[index].id) {
        this.stepsMustDelete.push(this.formData.instructionSteps[index].id);
      }
      this.formData.instructionSteps.splice(index, 1);
    },
    processJSON(json) {
      return json.results;
    },
    getDataSearchArea(data, area, item) {
      item.area = [area.area];
      this.updateShiftsTableData();
    },
    // updateAreaCheckBoxByValue(item, area) {
    //
    // },
    updateDeeplinkData() {
      if (!this.formData.deeplink.active) {
        this.formData.deeplink.id = null;
        this.formData.deeplink.item = 'checklist';
        this.formData.deeplink.badId = false;
        this.formData.deeplink.name = null;
      }
    },
    clearDeeplinkId() {
      this.formData.deeplink.id = null;
      this.formData.deeplink.id = null;
      this.formData.deeplink.badId = false;
      this.formData.deeplink.name = null;
      // Using direct change because of jQuery breaking
      // v-model connection not updating input value from model
      const deeplink = document.getElementById('deeplink-id');
      deeplink.value = null;
    },
    checkDeeplinkId() {
      let items = [];
      switch (this.formData.deeplink.item) {
        case 'task':
          items = this.taskTemplates;
          break;
        case 'audit':
          items = this.audits;
          break;
        case 'checklist':
          items = this.checklists;
          break;
        default:
          break;
      }
      console.log(items);
      this.formData.deeplink.badId = true;
      this.formData.deeplink.name = null;
      for (let i = 0; i < items.length; i++) {
        console.log(items[i].id);
        console.log(this.formData.deeplink.id);
        if (items[i].id === parseInt(this.formData.deeplink.id, 10)) {
          this.formData.deeplink.badId = false;
          this.formData.deeplink.name = items[i].name;
        }
      }
    },
    validateSteps() {
      for (let i = 0; i < this.formData.instructionSteps.length; i++) {
        this.formData.instructionSteps[i].valid = true;
      }
      for (let i = 0; i < this.formData.instructionSteps.length; i++) {
        const currentOrder = this.formData.instructionSteps[i].order;
        for (let j = i + 1; j < this.formData.instructionSteps.length; j++) {
          if (+this.formData.instructionSteps[j].order === currentOrder) {
            this.formData.instructionSteps[i].valid = false;
            this.formData.instructionSteps[j].valid = false;
          }
        }
      }
    },
    validateFormData() {
      this.alertError.title = 'Error!';
      for (let i = 0; i < this.formData.instructionSteps.length; i++) {
        if (!this.formData.instructionSteps[i].valid) {
          this.alertError.text = 'Please correct instructions for the tasks';
          this.alertError.visible = true;
          return false;
        }
      }
      this.alertError.text = 'Some fields are not filled';
      this.needFill = true;
      if (!this.formData.name) {
        this.alertError.text = 'Please fill field "Title"';
        this.alertError.visible = true;
        return false;
      }
      if (!this.formData.description) {
        this.alertError.text = 'Please fill field "Description"';
        this.alertError.visible = true;
        return false;
      }
      if (this.formData.selectedContent === 'video' &&
          ((this.formData.video_thumbnail || this.formData.img_thumbnail) &&
            !(this.formData.video || this.formData.video_url))) {
        this.formData.video_require = true;
        this.alertError.text = 'Please add video file';
        this.alertError.visible = true;
        return false;
      }
      if (this.formData.selectedContent === 'video' &&
          (!(this.formData.video_thumbnail || this.formData.img_thumbnail) &&
            (this.formData.video || this.formData.video_url))) {
        this.formData.video_require = true;
        this.alertError.text = 'Please add thumbnail image';
        this.alertError.visible = true;
        return false;
      }
      this.formData.video_require = false;
      this.checkDeeplinkId();
      if (this.formData.deeplink.active && this.formData.deeplink.badId) {
        this.alertError.text = 'Please correct "Deeplink to"';
        this.alertError.visible = true;
        return false;
      }
      // if (!this.formData.description_file && !this.formData.description_file_url) {
      //   for (let i = 0; i < this.formData.instructionSteps.length; i++) {
      //     if (!this.formData.instructionSteps[i].description) {
      //       this.alertError.text = 'WOOO!"';
      //       this.alertError.visible = true;
      //       return false;
      //     }
      //   }
      // }
      for (let i = 0; i < this.formData.instructionSteps.length; i++) {
        const step = this.formData.instructionSteps[i];
        step.video_require = false;
        if (step.selectedContent === 'video' &&
            ((step.video_thumbnail || step.img_thumbnail) &&
              !(step.video || step.video_url))) {
          step.video_require = true;
          this.alertError.text = 'Please add video file';
          this.alertError.visible = true;
          return false;
        }
        if (step.selectedContent === 'video' &&
            (!(step.video_thumbnail || step.img_thumbnail) &&
              (step.video || step.video_url))) {
          step.video_require = true;
          this.alertError.text = 'Please add thumbnail image';
          this.alertError.visible = true;
          return false;
        }
      }

      for (let i = 0; i < this.formData.workAreas.length; i++) {
        const workArea = this.formData.workAreas[i];
        if (!workArea.area.length) {
          this.alertError.text = 'Please select field "Working area"';
          this.alertError.visible = true;
          return false;
        }
        if (workArea.scheduler.type.selected === 0) {
          if (workArea.scheduler.fromDate === null && workArea.scheduler.toDate === null) {
            workArea.scheduler.forever = true;
          }
          if (!workArea.scheduler.forever &&
             ((workArea.scheduler.fromDate === null || Date(workArea.scheduler.fromDate) === 'Invalid Date'))) {
            this.alertError.text = 'Please fill field "From date"';
            this.alertError.visible = true;
            return false;
          }
          if (!workArea.scheduler.forever &&
               (workArea.scheduler.toDate === null || Date(workArea.scheduler.toDate) === 'Invalid Date')) {
            workArea.scheduler.toDate = null;
          }
          if (workArea.scheduler.tabIndex === 0) {
            const shifts = [];
            for (let j = 0; j < workArea.scheduler.byShift.items.length; j++) {
              for (const key in workArea.scheduler.byShift.items[j]) {
                if (workArea.scheduler.byShift.items[j][key].checked) {
                  shifts.push(workArea.scheduler.byShift.items[j][key].id);
                }
              }
            }
            if (!shifts.length) {
              this.alertError.text = 'Please select shifts';
              this.alertError.visible = true;
              return false;
            }
          }
          if (workArea.scheduler.tabIndex === 1 &&
              (workArea.scheduler.weekly.recurWeek < 1 ||
                (!workArea.scheduler.weekly.is_once_per_week &&
                !workArea.scheduler.weekly.selected.length))) {
            this.alertError.text = 'Please correct "Weekly"';
            this.alertError.visible = true;
            return false;
          }
          if (workArea.scheduler.tabIndex === 2) {
            const checkedFirst = document.getElementById(`monthlyType-${i}-1`).checked;
            if (checkedFirst) {
              if (workArea.scheduler.monthly.recurDay.day < 1 ||
                workArea.scheduler.monthly.recurDay.month < 1) {
                  this.alertError.text = 'Please correct "Monthly"';
                this.alertError.visible = true;
                return false;
              }
            } else if (workArea.scheduler.monthly.recurWeekDay.month < 1) {
              this.alertError.text = 'Please correct "Monthly"';
              this.alertError.visible = true;
              return false;
            }
          }
        } else {
          if (!workArea.scheduler.oneDay.date) {
            this.alertError.text = 'Please enter date in recurrence';
            this.alertError.visible = true;
            return false;
          }
          const shift = [];
          for (let j = 0; j < workArea.scheduler.oneDay.item.length; j++) {
            for (const key in workArea.scheduler.oneDay.item[j]) {
              if (workArea.scheduler.oneDay.item[j][key].checked) {
                shift.push(workArea.scheduler.oneDay.item[j][key].id);
              }
            }
          }
          // if (!shift.length) {
          //   this.alertError.text = 'Please select shift or change the date';
          //   this.alertError.visible = true;
          //   return false;
          // }
        }
      }
      this.needFill = false;
      return true;
    },
    deleteTask() {
      this.$refs.delete_task.show();
    },
    taskMustDelete() {
      const self = this;
      function allOk() {
        self.alertSuccess.text = 'Task successfully deleted, tab will be closed in 3 seconds';
        self.alertSuccess.visible = true;
        setTimeout(() => {
          window.close();
          //self.$router.push({ name: 'Tasks' });
        }, 3000);
      }
      function haveError() {
        self.alertError.text = 'Task did not deleted';
        self.alertError.visible = true;
        /*setTimeout(() => {
          self.$router.push({ name: 'Tasks' });
        }, 3000);*/
      }
      if (!this.taskId) {
        allOk();
        return;
      }
      this.sendDeleteTask()
        .then((response) => {
          if (response.status !== 200) {
            haveError();
            return;
          }
          allOk();
        })
        .catch(() => { haveError(); });
    },
    sendDeleteTask() {
      return this.$http.patch(`task-templates/${this.taskId}/`, { is_active: false },
        {
          method: 'PATCH',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
        })
        .then((response) => {
          if (response.status !== 200) {
            return response;
          }
          return response;
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
          return response;
        });
    },
    convertDate(date) {
      function formatXX(val) {
        if (val < 10) return `0${val}`;
        return `${val}`;
      }
      if (!date) {
        return null;
      }
      const newDate = new Date(date);
      const result = String(newDate.getFullYear()) + '-' +
        formatXX(newDate.getMonth() + 1) + '-' +
        formatXX(newDate.getDate());
      return result;
    },
    calculateImagesCount() {
      let result = 0;
      if (this.formData.picture) {
        console.log('this.formData.picture');
        result++;
      }
      if (this.formData.description_file) {
        result++;
      }
      result += this.formData.instructionSteps.filter(item => item.picture).length;
      console.log('calculateImagesCount', result);
      return result;
    },
    uploadVideo(data) {
      const uploadData = {
        filename: data.name,
      }
      if (this.$route.params.companyId) {
        uploadData.company = this.$route.params.companyId;
      }
      return this.$http.post('upload/', uploadData,
        {
          method: 'POST',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
          // emulateJSON: true,
        })
        .then((response) => {
          if (response.status !== 200) {
            this.alertError.text = this.getErrorText(response);
            return response.status;
          }
          return axios.put(response.body.upload_url, data,
            {
              method: 'PUT',
              headers: axios.defaults.headers.common,
              // {
              //   'content-type': 'video/mp4',
              // },
              // emulateJSON: true,
            })
            .then((resp) => {
              if (response.status !== 200) {
                this.alertError.text = this.getErrorText(resp);
                return resp.status;
              }
              return response.body.final_url;
            })
            .catch((response) => {
              if (response.status === 401) {
                this.onLogout();
              }
              this.alertError.text = this.getErrorText(response);
              return response;
            });
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
          this.alertError.text = this.getErrorText(response);
          return response;
        });
    },
    saveTaskVideo() {
      if (!this.formData.video || this.formData.selectedContent !== 'video') {
        return new Promise((resolve) => {
          resolve(false);
        });
      }
      return this.uploadVideo(this.formData.video)
      .then((urlVideo) => {
        console.log('uploadUrlVideo', urlVideo);
        this.formData.video_url = urlVideo;
        return null;
      });
    },
    // Deprecated
    // duplicateTask() {
    //   this.$router.push({ name: this.$route.name.replace('Change', 'Duplicate') });
    //   location.reload();
    //   // this.$router.go(this.$router.currentRoute);
    // },
    duplicateTask() {
      return this.$http.post(`task-templates/${this.taskId}/duplicate/`, {},
        {
          method: 'POST',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
          // emulateJSON: true,
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log('task duplication err', response);
            this.alertError.text = this.getErrorText(response);
            return response.status;
          }
          console.log('DUPLICATE RESPONSE', response );
          this.navigateTo(this.taskId, response.body.id);
          /*this.$router.push({ name: 'Task Configuration Change',
            params: { taskId: response.body.id } });*/
          return response.status;
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
          this.alertError.text = this.getErrorText(response);
          return response;
        });
    },
    saveTask(flagStandHere = false) {
      const self = this;
      // return self.saveTaskRecurrency(this.taskId);
      if (!this.validateFormData()) {
        return;
      }
      this.hasSaveError = false;
      // return;
      this.upload.total = this.calculateImagesCount();
      this.upload.uploaded = 0;
      this.upload.image = (this.upload.total !== 0);
      this.upload.visible = true;
      this.saveTaskVideo()
        .then(() => this.sendAddTaskTemplate())
        .then((response) => {
          if (response) {
            self.taskId = response;
            // if (!self.formData.description_file) {
            return self.saveTaskSteps(self.taskId);
            // }
          }
          console.log('sendAddTaskTemplate err', response);
          self.hasSaveError = true;
          return null;
        })
        .then(() => self.deleteTaskSteps(self.taskId))
        .then(() => {
          if (self.taskId) {
            return self.saveTaskRecurrency(self.taskId);
          }
          console.log('err NO taskID after post/patch task', self.taskId);
          self.hasSaveError = true;
          this.upload.visible = false;
          return null;
        })
        .then(() => {
          if (self.hasSaveError) {
            console.log('saveEnd save has errors');
            self.alertError.text = 'There were errors during the upload';
            self.alertError.visible = true;
            this.upload.visible = false;
          } else {
            console.log('saveEnd success');
            if(flagStandHere) {            
              self.alertSuccess.text = 'Saved successfully, a new tab will open in 3 seconds to add another Task';
            } else {
              self.alertSuccess.text = 'Saved successfully, tab will be closed in 3 seconds';
            }
            self.alertSuccess.visible = true;
            this.upload.visible = false;
            setTimeout(() => {
              //self.$router.push({ name: (flagStandHere) ? 'Task Configuration' : 'Tasks' });
              //location.reload();
              if(flagStandHere) {
                self.navigateTo(self.taskId, null);
              } else {
                window.close();
              }
              // this.$router.go(this.$router.currentRoute);
            }, 3000);
          }
        })
        .catch((response) => {
          console.log('ERRR have catch', response);
          self.alertError.text = 'There were errors during the upload';
          self.alertError.visible = true;
          this.upload.visible = false;
        });
      // this.saveTaskRecurrency(taskId);
    },
    navigateTo(taskIdToReplace, newTaskId) {
      var newUrl = window.location.href;
      var replacement = '';
      if (newTaskId) {
        replacement = '/' + newTaskId;
      }

      if(taskIdToReplace) {
        newUrl = newUrl.replace('/' + taskIdToReplace, replacement);
      }

      var win = window.open(newUrl, '_blank');
      win.focus();
      window.close();
    },
    saveTaskStepVideo(index) {
      if (!this.formData.instructionSteps[index].video) {
        return new Promise((resolve) => {
          resolve(false);
        });
      }
      return this.uploadVideo(this.formData.instructionSteps[index].video)
      .then((urlVideo) => {
        this.formData.instructionSteps[index].video_url = urlVideo;
        return null;
      });
    },
    saveTaskSteps(taskId) {
      const self = this;
      if (!self.formData.instructionSteps.length) {
        return null;
      }
      return new Promise((resolve) => {
        let count = 0;
        for (let i = 0; i < self.formData.instructionSteps.length; i++) {
          self.saveTaskStepVideo(i)
          .then(() => self.sendAddTaskStep(taskId, i))
          .then((response) => {
            if (response !== 201 && response !== 200) {
              console.log('sendAddTaskStep has err', response);
              self.hasSaveError = true;
            }
            count++;
            if (count === self.formData.instructionSteps.length) {
              resolve();
            }
          });
        }
      });
    },
    deleteTaskSteps() {
      const self = this;
      return new Promise((resolve) => {
        if (!self.stepsMustDelete.length) return resolve();
        let count = 0;
        for (let i = 0; i < self.stepsMustDelete.length; i++) {
          self.sendDeleteTaskStep(self.stepsMustDelete[i])
            .then((response) => {
              if (response.status !== 200) {
                console.log('sendDeleteTaskStep has err', response);
                self.hasSaveError = true;
              }
              count++;
              if (count === self.stepsMustDelete.length) {
                self.stepsMustDelete = [];
                resolve();
              }
            });
        }
        return null;
      });
    },
    saveTaskRecurrency(taskId) {
      const self = this;
      return new Promise((resolve) => {
        if (self.formData.workAreas.length === 0) return resolve();
        let count = 0;
        const mustSaveCount = self.recurrenciesMustDelete.length + self.formData.workAreas.length;
        for (let i = 0; i < self.recurrenciesMustDelete.length; i++) {
          self.sendDeleteRecurrency(taskId, self.recurrenciesMustDelete[i])
            .then((response) => {
              if (response != 201 && response != 200) {
                console.log('sendDeleteRecurrency has err', response);
                self.hasSaveError = true;
              }
              count++;
              if (count === mustSaveCount) {
                resolve();
              }
            });
        }
        for (let i = 0; i < self.formData.workAreas.length; i++) {
          self.sendAddRecurrency(taskId, i)
            .then((response) => {
              if (response != 201 && response != 200) {
                console.log('sendAddRecurrency has err', response);
                self.hasSaveError = true;
              }
              count++;
              if (count === mustSaveCount) {
                resolve();
              }
            });
        }
      });
    },
    sendDeleteRecurrency(taskId, recurId) {
      return this.$http.patch(`task-templates/${taskId}/recurrencies/${recurId}/`,
        { is_active: false },
        {
          method: 'PATCH',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log('recurrencies err', response);
            this.alertError.text = this.getErrorText(response);
            return response.status;
          }
          return response.status;
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
          this.alertError.text = this.getErrorText(response);
          return response;
        });
    },
    sendAddRecurrency(taskId, recurIndex) {
      const self = this;
      // no recurrency, shifts, week, month
      const workArea = this.formData.workAreas[recurIndex];

      let type = 'no recurrency';
      if (workArea.scheduler.type.selected === 0) {
        switch (workArea.scheduler.tabIndex) {
          case 0:
            type = 'shifts';
            break;
          case 1:
            type = 'week';
            break;
          case 2:
            type = 'month';
            break;
          default:
            break;
        }
      }
      const shifts = [];
      for (let i = 0; i < workArea.scheduler.byShift.items.length; i++) {
        for (const key in workArea.scheduler.byShift.items[i]) {
          if (workArea.scheduler.byShift.items[i][key].checked) {
            shifts.push(workArea.scheduler.byShift.items[i][key].id);
          }
        }
      }
      // let shift = [];
      const oneTimeShifts = [];
      for (let i = 0; i < workArea.scheduler.oneDay.item.length; i++) {
        for (const key in workArea.scheduler.oneDay.item[i]) {
          if (workArea.scheduler.oneDay.item[i][key].checked) {
            oneTimeShifts.push(workArea.scheduler.oneDay.item[i][key].id);
            // shift.push(workArea.scheduler.oneDay.item[i][key].id);
          }
        }
      }
      // shift = (shift.length) ? shift[0] : '';
      const data = {
        area: (workArea.area && workArea.area.length) ? (workArea.area[0].id) : null,
        type,
        date: this.convertDate(workArea.scheduler.oneDay.date),
        start_date: (workArea.scheduler.forever ?
          null : this.convertDate(workArea.scheduler.fromDate)),
        end_date: (workArea.scheduler.forever ?
          null : this.convertDate(workArea.scheduler.toDate)),
        // shift,
        one_time_shifts: oneTimeShifts,
        shifts,
        week: workArea.scheduler.weekly.recurWeek,
        // weekday: workArea.scheduler.weekly.selected,
        weekday0: workArea.scheduler.weekly.selected.indexOf(1) + 1 > 0,
        weekday1: workArea.scheduler.weekly.selected.indexOf(2) + 1 > 0,
        weekday2: workArea.scheduler.weekly.selected.indexOf(3) + 1 > 0,
        weekday3: workArea.scheduler.weekly.selected.indexOf(4) + 1 > 0,
        weekday4: workArea.scheduler.weekly.selected.indexOf(5) + 1 > 0,
        weekday5: workArea.scheduler.weekly.selected.indexOf(6) + 1 > 0,
        weekday6: workArea.scheduler.weekly.selected.indexOf(7) + 1 > 0,
        is_once_per_week: workArea.scheduler.weekly.is_once_per_week,
        is_once_per_month: workArea.scheduler.monthly.is_once_per_month,
        day: workArea.scheduler.monthly.recurDay.day,
        month: workArea.scheduler.monthly.recurDay.month,
        month_recurrency: 'day_of_month',
      };
      const monthlyType = document.getElementById(`monthlyType-${recurIndex}-2`);
      if (monthlyType && monthlyType.checked) {
        data.month_recurrency = 'weekday';
        data.weekday_number = workArea.scheduler.monthly.recurWeekDay.every;
        data.weekday = workArea.scheduler.monthly.recurWeekDay.weekDay;
        data.month = workArea.scheduler.monthly.recurWeekDay.month;
      }
      // return;
      if (!workArea.scheduler.id) {
        return this.$http.post(`task-templates/${taskId}/recurrencies/`, data,
          {
            method: 'POST',
            headers: {
              Authorization: `Token ${this.access_token}`,
            },
            // emulateJSON: true,
          })
          .then((response) => {
            if (response.status !== 201) {
              console.log('recurrencies err', response);
              this.alertError.text = this.getErrorText(response);
              return response.status;
            }
            workArea.scheduler.id = response.body.id;
            return response.status;
          })
          .catch((response) => {
            if (response.status === 401) {
              this.onLogout();
            }
            this.alertError.text = this.getErrorText(response);
            return response;
          });
      }
      return this.$http.patch(`task-templates/${taskId}/recurrencies/${workArea.scheduler.id}/`, data,
        {
          method: 'PATCH',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
          // emulateJSON: true,
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log('recurrencies err', response);
            this.alertError.text = this.getErrorText(response);
            return response.status;
          }
          return response.status;
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
          this.alertError.text = this.getErrorText(response);
          return response;
        });
    },
    sendAddTaskStep(taskId, stepIndex) {
      const self = this;
      const step = this.formData.instructionSteps[stepIndex];

      const data = {
        template: taskId,
        index: step.order,
        description: step.description,
        picture: (step.selectedContent === 'image') ? step.picture : '',
        video: (step.selectedContent === 'video' && step.video_url) ? step.video_url : '',
        video_thumbnail: (step.selectedContent === 'video' && step.video_url) ? step.video_thumbnail : '',
      };
      const formData = new FormData();
      for (const key in data) {
        if (key !== 'picture' && key !== 'video_thumbnail') {
          formData.append(key, data[key]);
        }
      }
      if (!this.formData.instructionSteps[stepIndex].id) {
        formData.append('picture', data.picture);
        formData.append('video_thumbnail', data.video_thumbnail);
        // Deprecated
        // if (this.duplicate) {
        //   console.log('save task', data);
        //   if (data.video_thumbnail) {
        //     console.log('save task v', data);
        //     let blob = new Blob([data.video_thumbnail], { type : 'image/jpeg' });
        //     // let fileOfBlob = new File([blob], 'thumbnail.jpg', { type : 'image/jpeg' });
        //     // form.append("upload", fileOfBlob);
        //     // formData.append('video_thumbnail', fileOfBlob);
        //     formData.append('video_thumbnail', blob, 'thumbnail.jpg');
        //   }
        //   if (data.picture) {
        //     console.log('save task p', data);
        //     let blob = new Blob([data.picture], { type : 'image/jpeg' });
        //     // let fileOfBlob = new File([blob], 'photo.jpg', { type : 'image/jpeg' });
        //     // form.append("upload", fileOfBlob);
        //     // formData.append('picture', fileOfBlob);
        //     formData.append('picture', blob, 'photo.jpg');
        //   }
        // } else {
        //   formData.append('picture', data.picture);
        //   formData.append('video_thumbnail', data.video_thumbnail);
        // }
        return this.$http.post('task-steps/', formData,
          {
            method: 'POST',
            headers: {
              Authorization: `Token ${this.access_token}`,
            },
            // progress(e) {
            //   console.log('e', e);
            //   if (e.lengthComputable) {
            //     console.log((e.loaded / e.total) * 100);
            //   }
            // },
            // emulateJSON: true,
          })
          .then((response) => {
            if (response.status !== 201) {
              console.log('POST step err ', response);
              this.alertError.text = this.getErrorText(response);
              return response.status;
            }
            self.formData.instructionSteps[stepIndex].id = response.body.id;
            if (data.picture) this.upload.uploaded++;
            return response.status;
          })
          .catch((response) => {
            if (response.status === 401) {
              this.onLogout();
            }
            this.alertError.text = this.getErrorText(response);
            return response;
          });
      }
      console.log('step', step.selectedContent === 'picture', step.selectedContent);
      if (!(step.img && !step.picture)) {
        console.log('add picture', data);
        formData.append('picture', data.picture);
      }
      if (!(step.img_thumbnail && !step.video_thumbnail)) {
        formData.append('video_thumbnail', data.video_thumbnail);
      }
      return this.$http.patch(`task-steps/${this.formData.instructionSteps[stepIndex].id}/`,
        formData,
        {
          method: 'PATCH',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
          // progress(e) {
          //   console.log('e', e);
          //   if (e.lengthComputable) {
          //     console.log((e.loaded / e.total) * 100);
          //   }
          // },
          // emulateJSON: true,
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log('PATCH step err', response);
            this.alertError.text = this.getErrorText(response);
            return response.status;
          }
          if (data.picture) this.upload.uploaded++;
          return response.status;
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
          this.alertError.text = this.getErrorText(response);
          return response;
        });
    },
    sendDeleteTaskStep(stepId) {
      return this.$http.patch(`task-steps/${stepId}/`, { is_active: false },
        {
          method: 'PATCH',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
          // emulateJSON: true,
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log('DELETE step err ', response);
            return response;
          }
          return response;
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
          this.alertError.text = this.getErrorText(response);
          return response;
        });
    },
    sendAddTaskTemplate() {
      const form = this.formData;
      const data = {
        name: form.name,
        picture: (form.selectedContent === 'image') ? form.picture : '',
        description: form.description,
        description_file: form.description_file,
        video: (form.selectedContent === 'video' && form.video_url) ? form.video_url : '',
        video_thumbnail: (form.selectedContent === 'video' && form.video_url) ? form.video_thumbnail : '',
        // area: 2,
        role: form.role,
        // company_id: this.authUser.company.id,
      };
      if (!data.description_file) {
        data.description_file = '';
      }
      if (form.description_file_url) {
        delete (data.description_file);
      }

      if (this.$route.params.companyId) {
        data.company = this.$route.params.companyId;
      }
      if (form.deeplink.active) {
        data.deeplink_to = form.deeplink.item;
        data.deeplink_id = form.deeplink.id;
      } else {
        data.deeplink_to = '';
        data.deeplink_id = '';
      }
      const formData = new FormData();
      for (const key in data) {
        if (key !== 'picture' && key !== 'video_thumbnail') {
          formData.append(key, data[key]);
        }
      }
      // return;
      if (!this.taskId) {
        formData.append('picture', data.picture);
        formData.append('video_thumbnail', data.video_thumbnail);
        // Deprecated
        // if (this.duplicate) {
        //   if (data.video_thumbnail) {
        //     let blob = new Blob([data.video_thumbnail], { type : 'image/jpeg' });
        //     // let fileOfBlob = new File([blob], 'thumbnail.jpg', { type : 'image/jpeg' });
        //     // form.append("upload", fileOfBlob);
        //     // formData.append('video_thumbnail', fileOfBlob);
        //     formData.append('video_thumbnail', blob, 'thumbnail.jpg');
        //   }
        //   if (data.picture) {
        //     let blob = new Blob([data.picture], { type : 'image/jpeg' });
        //     // let fileOfBlob = new File([blob], 'photo.jpg', { type : 'image/jpeg' });
        //     // form.append("upload", fileOfBlob);
        //     // formData.append('picture', fileOfBlob);
        //     formData.append('picture', blob, 'photo.jpg');
        //   }
        // } else {
        //   formData.append('picture', data.picture);
        //   formData.append('video_thumbnail', data.video_thumbnail);
        // }
        return this.$http.post('task-templates/', formData,
          {
            method: 'POST',
            headers: {
              Authorization: `Token ${this.access_token}`,
            },
            // emulateJSON: true,
          })
          .then((response) => {
            if (response.status !== 201) {
              console.log('POST task err', response);
              this.alertError.text = this.getErrorText(response);
              return null;
            }
            if (data.picture) this.upload.uploaded++;
            if (data.video_thumbnail) this.upload.uploaded++;
            return response.body.id;
          })
          .catch((response) => {
            if (response.status === 401) {
              this.onLogout();
            }
            this.alertError.text = this.getErrorText(response);
            return response;
          });
      }
      if (!(form.img && !form.picture)) {
        formData.append('picture', data.picture);
      }
      if (!(form.img_thumbnail && !form.video_thumbnail)) {
        formData.append('video_thumbnail', data.video_thumbnail);
      }
      return this.$http.patch(`task-templates/${this.taskId}/`, formData,
        {
          method: 'PATCH',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
          // emulateJSON: true,
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log('PATCH', response);
            // that.$set(that, 'moduleError', true);
            this.alertError.text = this.getErrorText(response);
            return null;
          }
          if (data.picture) this.upload.uploaded++;
          if (data.video_thumbnail) this.upload.uploaded++;
          return response.body.id;
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
          this.alertError.text = this.getErrorText(response);
          return response;
        });
    },
    getWorkingAreas() {
      let url = 'areas/?is_system=false';
      if (this.$route.params.companyId) {
        url = `${url}&company=${this.$route.params.companyId}`;
      }
      return this.$http.get(url,
        {
          method: 'GET',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
          // emulateJSON: true,
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log(response);
            // that.$set(that, 'moduleError', true);
            this.alertError.text = this.getErrorText(response);
            return;
          }
          // response.body.activeId = false;
          // this.areas = [];
          // this.areas.push(response.body);
          this.areas = response.body;
          // return response;
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
        });
    },
    sortShifts(shifts) {
      shifts.sort((a, b) => {
        if (a.start === b.start) {
          return a.end > b.end;
        }
        return a.start > b.start;
      });
    },
    getShiftList() {
      let url = 'shifts/';
      if (this.$route.params.companyId) {
        url = `${url}?company=${this.$route.params.companyId}`;
      }
      return this.$http.get(url,
        {
          method: 'GET',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
          // emulateJSON: true,
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log(response);
            this.alertError.text = this.getErrorText(response);
            return;
          }
          this.shifts = {
            monday: [],
            tuesday: [],
            wednesday: [],
            thursday: [],
            friday: [],
            saturday: [],
            sunday: [],
          };
          this.sortShifts(response.body);
          for (let i = 0; i < response.body.length; i++) {
            for (const key in this.formData.workAreas[0].scheduler.byShift.fields) {
              if (this.formData.workAreas[0].scheduler.byShift.fields[key].value ===
                  response.body[i].day) {
                const time = `${response.body[i].start.split(':')[0]}:${response.body[i].start.split(':')[1]}-${
                  response.body[i].end.split(':')[0]}:${response.body[i].end.split(':')[1]}`;
                const newData = {
                  id: response.body[i].id,
                  time,
                  checked: false,
                  area: response.body[i].area,
                };
                this.shifts[key].push(newData);
              }
            }
          }
          this.updateShiftsTableData();
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
        });
    },
    selectedAreaChanged(area) {
      console.log('areachanged', area[0].name);
    },
    updateSuggestArea() {
      this.formData.suggestArea = [];
      const areaPaths = this.getUserAreaPath(this.areas);
      for (let i = 0; i < areaPaths.length; i++) {
        this.formData.suggestArea.push(areaPaths[i]);
      }
    },
    getUserAreaPath(area) {
      const result = [];
      for (let i = 0; i < area.length; i++) {
        const res = this.getUserAreaPath(area[i].subareas);
        for (let j = 0; j < res.length; j++) {
          result.push({ name: `${area[i].name}/${res[j].name}`, area: res[j].area });
        }
        if (res.length === 0) {
          result.push({ name: area[i].name, area: area[i] });
        }
      }
      return result;
    },
    getTaskTemplatesList() {
      let url = 'task-templates/' + this.$route.params.taskId;
      this.$http.get(url,
        {
          method: 'GET',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
          // emulateJSON: true,
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log(response);
            return;
          }
          this.taskTemplates = [response.body];
          this.fillAllData();
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
        });
    },
    getAuditsList() {
      let url = 'audit-templates/';
      if (this.$route.params.companyId) {
        url = `${url}?company=${this.$route.params.companyId}`;
      }
      this.$http.get(url,
        {
          method: 'GET',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
          // emulateJSON: true,
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log(response);
            this.alertError.text = this.getErrorText(response);
            return;
          }
          this.audits = response.body;
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
        });
    },
    getChecklistList() {
      let url = 'checklist-templates/';
      if (this.$route.params.companyId) {
        url = `${url}?company=${this.$route.params.companyId}`;
      }
      this.$http.get(url,
        {
          method: 'GET',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
          // emulateJSON: true,
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log(response);
            this.alertError.text = this.getErrorText(response);
            return;
          }
          this.checklists = response.body;
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
        });
    },
    clearVideo(e) {
      if (this.formData.video_url) {
        this.formData.video_url = '';
        this.$refs.videofile.reset();
        e.preventDefault();
        return;
      }
      if (!this.formData.video) {
        return;
      }
      this.$refs.videofile.reset();
      e.preventDefault();
    },
    clearStepVideo(e, step, index) {
      if (step.video_url) {
        step.video_url = '';
        this.$refs.stepvideofile[index].reset();
        e.preventDefault();
        return;
      }
      if (!step.video) {
        return;
      }
      this.$refs.stepvideofile[index].reset();
      e.preventDefault();
    },
    clearPdfFile(e) {
      if (this.formData.description_file_url) {
        this.formData.description_file_url = '';
        this.$refs.pdffile.reset();
        e.preventDefault();
        return;
      }
      if (!this.formData.description_file) {
        return;
      }
      this.$refs.pdffile.reset();
      e.preventDefault();
    },
    changePdfFile() {
      if (!this.formData.description_file) {
        return null;
      }
      if (this.formData.description_file &&
          this.formData.description_file.size > 5000000) {
        this.$refs.pdffile.reset();
        this.alertError.text = 'Maximum allowed file size is 5 MB.';
        this.alertError.visible = true;
      }
      return null;
    },
    getBackUrl() {
      return `${process.env.START_URL}/`;
    },
    fillTestParam() {
      this.formData.name = 'test create task cascade 3';
      this.formData.description = 'description2';
    },
    getAreaById(id, area = this.areas) {
      for (let i = 0; i < area.length; i++) {
        if (area[i].id === id) {
          return area[i];
        }
        const res = this.getAreaById(id, area[i].subareas);
        if (res) {
          return res;
        }
      }
      return null;
    },
    downloadImage(url) {
      return axios.get(url, {
        headers: axios.defaults.headers.common,
        responseType: 'arraybuffer',
      })
      .then((resp) => {
        if (resp.status !== 200) {
          return null;
        }
        return resp.data;
      })
      .catch((response) => {
        console.log('download complite error', response);
        if (response.status === 401) {
          this.onLogout();
        }
        this.alertError.text = this.getErrorText(response);
        return null;
      });
    },
    fillAllData() {
      // function getFilenameFromUrl(url) {
      //   if (!url) return null;
      //   let result = url.split('/');
      //   result = result[result.length - 1];
      //   return result;
      // }
      if (!this.taskId) {
        return;
      }
      for (let i = 0; i < this.taskTemplates.length; i++) {
        if (this.taskTemplates[i].id !== this.taskId) continue;
        // Deprecated
        // if (this.taskId && this.duplicate) {
        //   this.taskId = 0;
        // }
        this.formData.name = this.taskTemplates[i].name;
        this.formData.description = this.taskTemplates[i].description;
        this.formData.role = this.taskTemplates[i].role;
        // this.formData.img = getFilenameFromUrl(this.taskTemplates[i].picture);
        this.formData.img = (this.taskTemplates[i].picture);
        this.formData.img_thumbnail = (this.taskTemplates[i].video_thumbnail);
        this.formData.video_url = (this.taskTemplates[i].video);
        if (this.formData.img) {
          this.formData.selectedContent = 'image';
        }
        if (this.formData.video_url) {
          this.formData.img = '';
          this.formData.selectedContent = 'video';
        }
        // Deprecated
        // if (this.duplicate) {
        //   if (this.formData.img) {
        //     this.downloadImage(this.formData.img)
        //     .then((resp) => {
        //       if (resp) {
        //         this.formData.picture = resp;
        //       }
        //     })
        //     .catch((resp) => {
        //       console.log('err', resp);
        //     });
        //   }
        //   if (this.formData.img_thumbnail) {
        //     this.downloadImage(this.formData.img_thumbnail)
        //     .then((resp) => {
        //       if (resp) {
        //         this.formData.video_thumbnail = resp;
        //       }
        //     })
        //     .catch((resp) => {
        //       console.log('err', resp);
        //     });
        //   }
        // }
        this.formData.description_file_url = this.taskTemplates[i].description_file;
        if (this.taskTemplates[i].deeplink_id && this.taskTemplates[i].deeplink_to) {
          this.formData.deeplink.active = true;
          this.formData.deeplink.item = this.taskTemplates[i].deeplink_to;
          this.formData.deeplink.id = this.taskTemplates[i].deeplink_id;
        }
        for (let j = 0; j < this.taskTemplates[i].steps.length; j++) {
          const step = this.taskTemplates[i].steps[j];
          while (this.formData.instructionSteps.length < j + 1) {
            this.addNewStep();
          }
          // Deprecated
          // if (!this.duplicate) {
          //   this.formData.instructionSteps[j].id = step.id;
          // }
          this.formData.instructionSteps[j].id = step.id;
          this.formData.instructionSteps[j].order = step.index;
          this.formData.instructionSteps[j].description = step.description;
          // this.formData.instructionSteps[j].img = getFilenameFromUrl(step.picture);
          this.formData.instructionSteps[j].img = step.picture;
          this.formData.instructionSteps[j].valid = true;
          this.formData.instructionSteps[j].img_thumbnail = (step.video_thumbnail);
          this.formData.instructionSteps[j].video_url = (step.video);
          if (this.formData.instructionSteps[j].img) {
            this.formData.instructionSteps[j].selectedContent = 'image';
          }
          if (this.formData.instructionSteps[j].video_url) {
            this.formData.instructionSteps[j].img = '';
            this.formData.instructionSteps[j].selectedContent = 'video';
          }
          // Deprecated
          // if (this.duplicate) {
          //   if (this.formData.instructionSteps[j].img) {
          //     this.downloadImage(this.formData.instructionSteps[j].img)
          //     .then((resp) => {
          //       if (resp) {
          //         this.formData.instructionSteps[j].picture = resp;
          //       }
          //     })
          //     .catch((resp) => {
          //       console.log('err', resp);
          //     });
          //   }
          //   if (this.formData.instructionSteps[j].img_thumbnail) {
          //     this.downloadImage(this.formData.instructionSteps[j].img_thumbnail)
          //     .then((resp) => {
          //       if (resp) {
          //         this.formData.instructionSteps[j].video_thumbnail = resp;
          //       }
          //     })
          //     .catch((resp) => {
          //       console.log('err', resp);
          //     });
          //   }
          // }
        }
        for (let j = 0; j < this.taskTemplates[i].recurrencies.length; j++) {
          const recurrence = this.taskTemplates[i].recurrencies[j];
          // if (!recurrence.is_active) continue;
          console.log('recurrence', recurrence);
          if (!this.getAreaById(recurrence.area)) {
            console.log('no area id=', recurrence.area);
            continue;
          }
          while (this.formData.workAreas.length < j + 1) {
            this.addOneMoreArea();
          }
          this.formData.workAreas[j].area.push(this.getAreaById(recurrence.area));
          // Deprecated
          // if (!this.duplicate) {
          //   this.formData.workAreas[j].scheduler.id = recurrence.id;
          // }
          this.formData.workAreas[j].scheduler.id = recurrence.id;
          this.formData.workAreas[j].scheduler.fromDate = recurrence.start_date;
          this.formData.workAreas[j].scheduler.toDate = recurrence.end_date;
          this.formData.workAreas[j].scheduler.forever =
            !(recurrence.start_date || recurrence.end_date);
          if (recurrence.type === 'no recurrency') {
            this.formData.workAreas[j].scheduler.type.selected = 1;
            this.formData.workAreas[j].scheduler.oneDay.date = recurrence.date;
            this.formData.workAreas[j].scheduler.oneDay.shifts = recurrence.one_time_shifts;
          } else {
            this.formData.workAreas[j].scheduler.type.selected = 0;
            if (recurrence.type === 'shifts') {
              this.formData.workAreas[j].scheduler.tabIndex = 0;
            }
            if (recurrence.type === 'week') {
              this.formData.workAreas[j].scheduler.tabIndex = 1;
              this.formData.workAreas[j].scheduler.weekly.recurWeek = recurrence.week;
              this.formData.workAreas[j].scheduler.weekly.is_once_per_week =
                (recurrence.is_once_per_week === true);
              this.formData.workAreas[j].scheduler.weekly.selected = [];
              for (let weekday = 0; weekday < 7; weekday++) {
                if (recurrence[`weekday${weekday}`]) {
                  this.formData.workAreas[j].scheduler.weekly.selected.push(weekday + 1);
                }
              }
            }
            if (recurrence.type === 'month') {
              this.formData.workAreas[j].scheduler.tabIndex = 2;
              this.formData.workAreas[j].scheduler.monthly.recurDay.day = recurrence.day;
              this.formData.workAreas[j].scheduler.monthly.recurDay.month = recurrence.month;
              this.formData.workAreas[j].scheduler.monthly.is_once_per_month =
                (recurrence.is_once_per_month === true);
              // month_recurrency (weekday или day_of_month)
              if (recurrence.month_recurrency === 'weekday') {
                setTimeout(() => {
                  document.getElementById(`monthlyType-${j}-2`).checked = true;
                }, 1);
                this.formData.workAreas[j].scheduler.monthly.recurWeekDay.every =
                  recurrence.weekday_number;
                this.formData.workAreas[j].scheduler.monthly.recurWeekDay.weekDay =
                  recurrence.weekday ? recurrence.weekday : 1;
                this.formData.workAreas[j].scheduler.monthly.recurWeekDay.month =
                  recurrence.month;
              }
            }
          }
          // this.formData.workAreas[j].scheduler.shifts
        }
        this.updateShiftsTableData();
        for (let j = 0; j < this.formData.workAreas.length; j++) {
          const recurrence = this.taskTemplates[i].recurrencies[j];
          const workArea = this.formData.workAreas[j].scheduler.byShift;
          for (let itemIndex = 0; itemIndex < workArea.items.length; itemIndex++) {
            for (const key in workArea.items[itemIndex]) {
              workArea.items[itemIndex][key].checked = false;
              if (recurrence.shifts.indexOf(workArea.items[itemIndex][key].id) + 1) {
                workArea.items[itemIndex][key].checked = true;
              }
            }
          }
          const workAreaOneDay = this.formData.workAreas[j].scheduler.oneDay;
          for (let itemIndex = 0; itemIndex < workAreaOneDay.items.length; itemIndex++) {
            for (const key in workAreaOneDay.items[itemIndex]) {
              workAreaOneDay.items[itemIndex][key].checked = false;
              if (recurrence.one_time_shifts.indexOf(workAreaOneDay.items[itemIndex][key].id) + 1) {
                workAreaOneDay.items[itemIndex][key].checked = true;
              }
            }
          }
        }
        this.processLoading = false;
        return;
      }
      this.processLoading = false;
      this.alertError.text = 'Task not found';
      this.alertError.visible = true;
      // setTimeout(() => this.$router.push({ name: 'Tasks' }), 3000);
    },
    getErrorText(response) {
      const result = `There were errors during the upload (${response.status})`;
      if (response.status === 400) {
        if (!response.body) {
          return 'Large file';
        }
        for (const key in response.body) {
          return `${key}: ${response.body[key]}`;
        }
      }
      if (response.status === 401) {
        return 'Invalid authorization, please relogin';
      }
      if (response.status === 404) {
        return 'Not found (404)';
      }
      if (response.status === 500) {
        return 'Internal server error';
      }
      return result;
    },
    initData() {
      Object.assign(this.$data, this.$options.data.apply(this));
      // this.fillTestParam();
      this.taskId = +this.$route.params.taskId;
      // this.taskId = 354;
      if (this.taskId) {
        this.processLoading = true;
      }
      this.getCompany();
      // this.createUserRoles();
      this.createShiftsField();
      // this.addNewStep();
      this.addOneMoreArea();
      this.getWorkingAreas()
        .then(() => this.getShiftList())
        .then(() => this.getTaskTemplatesList())
        .catch(() => {
          this.alertError.text = 'An error occurred while loading the data. Please refresh the page.';
          this.alertError.visible = true;
          this.processLoading = false;
        });
      this.getAuditsList();
      this.getChecklistList();
    },
  },
  computed: {
  },
  created() {
    this.initData();
  },
  watch: {
    $route(to, from) {
      if (to.name === 'Task Configuration Change' || to.name === 'Task Configuration Change SuperUser') {
        this.processLoading = true;
        this.taskId = to.params.taskId;
        this.formData.id = to.params.taskId;
        this.initData();
      }
  },
    areas() {
      this.updateSuggestArea();
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/taskConfig/taskConfig.component.js